var map = {
	"./": 480,
	"./OldUi": 2711,
	"./OldUi.js": 2711,
	"./SpireonNew": 2712,
	"./SpireonNew.js": 2712,
	"./SpireonOld": 2713,
	"./SpireonOld.js": 2713,
	"./index": 480,
	"./index.js": 480,
	"./style": 372,
	"./style.js": 372
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4227;